<script>
  import { PHASE_MESSAGE_LANGUAGES } from "../Project/phaseMessages.js";
  import { Select } from "paxray-components-svelte";

  export let messages; // { en, de, fr, it, es } for the user message
  export let value = ""; // bound message, replaced when the language changes
  export let consents = null; // optional consent texts in the same languages
  export let consent = ""; // bound consent text, replaced alongside the message
  export let language = "en";

  const selectOptions = PHASE_MESSAGE_LANGUAGES.map((option) => ({
    value: option.value,
    text: option.label,
  }));

  function selectLanguage(event) {
    language = event.target.value;
    value = messages[language] ?? value;
    if (consents) consent = consents[language] ?? consent;
  }
</script>

<div class="phase_message_language" role="group" aria-label="Language">
  <Select
    items={selectOptions}
    selected={language}
    showPlaceholder={false}
    fitContent
    on:change={selectLanguage}
    color="dark"
  />
</div>

<style>
  .phase_message_language {
    display: flex;
    align-items: center;
    gap: var(--control-gap);
    margin-left: auto;
  }
</style>
